import { AppSidebar } from "@/components/app-layout/AppSidebar";
import { SidebarContentAdmin } from "@/components/app-layout/menus/SidebarContentSettings";
import { useOrganizationData } from "@/data/use-organizations-data";
import {
  faCircleInfo,
  faFlag,
  faMessageCode,
  faUsers,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Outlet, useParams } from "@tanstack/react-router";

export const GlobalAdminOrganizationLayout = () => {
  const { organizationUuid } = useParams({ strict: false }) as {
    organizationUuid: string;
  };
  const { organization } = useOrganizationData(organizationUuid);

  if (!organization) return null;

  return (
    <>
      <AppSidebar.ContentPortal>
        <SidebarContentAdmin
          title={`Organization: ${organization.name}`}
          settings={[
            {
              name: "Details",
              link: {
                to: "/admin/organizations/$organizationUuid/details",
                params: { organizationUuid },
              },
              icon: faCircleInfo,
            },
            {
              name: "Feature Flags",
              link: {
                to: "/admin/organizations/$organizationUuid/feature-flags",
                params: { organizationUuid },
              },
              icon: faFlag,
            },
            {
              name: "Members",
              link: {
                to: "/admin/organizations/$organizationUuid/members",
                params: { organizationUuid },
              },
              icon: faUsers,
            },
            {
              name: "Custom Prompts",
              link: {
                to: "/admin/organizations/$organizationUuid/custom-prompts",
                params: { organizationUuid },
              },
              icon: faMessageCode,
            },
          ]}
        />
      </AppSidebar.ContentPortal>
      <Outlet />
    </>
  );
};
